export type UserInfoCookie = {
  userName: string
  email: string
}

export const parseUserInfoCookie = (value: string | undefined): UserInfoCookie | null => {
  if (!value) return null

  try {
    const parsed = JSON.parse(value) as unknown
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null

    const record = parsed as Record<string, unknown>
    if (typeof record.userName !== "string" || typeof record.email !== "string") return null
    return { userName: record.userName, email: record.email }
  } catch {
    return null
  }
}
